import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../core/_requests'
import {emailValidation} from '../../user/components/forms/helper/ValidationHelperComponent'
import MetaTags from '../../../meta/MetaTags'
import PrimaryButton from '../../user/components/common/buttons/PrimaryButton'
import {FaChevronLeft} from 'react-icons/fa'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: emailValidation,
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      try {
        await requestPassword(values.email)
        setHasErrors(false)
      } catch (error) {
        setHasErrors(true)
        setStatus('The login detail is incorrect')
      } finally {
        setLoading(false)
        setSubmitting(false)
      }
    },
  })

  return (
    <>
      <MetaTags title={'Forgot Password'} />

      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          <Link to={'/login'}>
            <FaChevronLeft className='text-white d-flex cursor-pointer fs-2 bg-primary p-2 rounded-circle' />
          </Link>
          {/* begin::Title */}
          <h1 className=' fw-bolder mb-3'>Forgot Password ?</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-500 fw-semibold fs-6'>
            Enter your email to reset your password.
          </div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {/* {hasErrors === true && (
          <div className='mb-lg-3 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              Sorry, looks like there are some errors detected, please try again.
            </div>
          </div>
        )} */}

        {(hasErrors === false || hasErrors === true) && (
          <div className='p text-green mb-lg-3 alert alert-success'>
            <p className='text-green'>
              If an account exists for that address, you'll receive a password reset link shortly.
            </p>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
          <input
            type='email'
            placeholder='Enter Email'
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <PrimaryButton type='submit' id='kt_password_reset_submit' className='w-100 bg-primary' disabled={loading}>
            {loading ? (
              <>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </>
            ) : (
              'Reset Password'
            )}
          </PrimaryButton>
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
